<loader *ngIf="!currentOrder"></loader>

<section *ngIf="currentOrder">
  <order-header
    *ngIf="currentOrder.statusCode != 'DRAFT'"
    (onChatOpen)="onChatOpenClicked($event)"
  ></order-header>

  <router-outlet></router-outlet>
</section>

<modal-popup
  *ngIf="displayChatPopup"
  [flexible]="true"
  [hideHeader]="false"
  [isOpen]="displayChatPopup"
  [focusOnOpen]="false"
  (onClose)="displayChatPopup = false"
  [title]="(currentChatContact$ | async).chatTitle"
  [padding]="false"
  [wide]="true"
>
  <order-chat
    [contact]="currentChatContact$ | async"
    [order]="currentOrder"
    (onCreateTask)="createChatTask($event)"
  ></order-chat>
</modal-popup>

<modal-popup
  *ngIf="displayChatTaskPopup && (selectedChatTask$ | async)"
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayChatTaskPopup = false"
  [isOpen]="displayChatTaskPopup"
>
  <edit-chat-task
    [task]="selectedChatTask$ | async"
    (onCancel)="displayChatTaskPopup = false"
  ></edit-chat-task>
</modal-popup>
